export enum BrugerRolleEnum {
    Administrator = 1,
    Laerer = 2,
    Elev = 3,
    Ekstern = 4
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/enums/BrugerRolleEnum.ts